import { css, useTheme } from "@emotion/react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import React from "react";

const SineWave = (props) => {
  const { color: colors } = useTheme();
  return (
    <motion.svg
      fill="none"
      height="202"
      viewBox="0 0 1596 202"
      width="1596"
      xmlns="http://www.w3.org/2000/svg"
      // exit={{
      //   opacity: 0,
      // }}
      {...props}
    >
      <motion.path
        animate={{
          pathLength: 1,
        }}
        d="M-57 3C27 3 69.2857 199 187.286 199C305.286 199 300.571 3 431.571 3C562.571 3 557.857 199 675.857 199C793.857 199 802.643 3 920.143 3C1037.64 3 1027.43 199 1164.43 199C1301.43 199 1295.71 3 1408.71 3C1521.71 3 1529 199 1653 199"
        initial={{
          pathLength: 0,
        }}
        opacity="0.3"
        stroke="url(#paint0_linear)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="5"
        transition={{
          duration: 3,
        }}
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear"
          x1="25.6864"
          x2="1683.43"
          y1="141.336"
          y2="141.336"
        >
          <stop stopColor={colors.start} />
          <stop offset="1" stopColor={colors.end} />
        </linearGradient>
      </defs>
    </motion.svg>
  );
};

export const SineWaveBad = () => {
  const width = 800;
  const segments = 100;

  const amplitude = useMotionValue(100);
  const frequency = useSpring(5);

  const arr = new Array(100).fill(undefined);
  const points = useTransform(frequency, (freq) =>
    arr
      .map((_, i) => {
        const period = i / segments;
        const cycle = Math.sin(period * freq * Math.PI * 2);
        return {
          x: (i * width) / segments,
          y: (cycle * amplitude.get()) / 2,
        };
      })
      .map(({ x, y }) => `${x},${y}`)
      .join(" ")
  );

  const { color } = useTheme();
  const logoStops = color.logoStops?.filter(
    (stop) => stop.toLowerCase() !== "#ffffff"
  );

  return (
    <div
      css={css`
        width: 100%;
        height: 100%;
        overflow: hidden;
      `}
    >
      <motion.svg
        css={css`
          /* width: 200vw; */
          width: 100vw;
          height: 100%;
        `}
        initial={{
          x: "0",
        }}
        version="1.1"
        viewBox="0 0 800 200"
        xmlns="http://www.w3.org/2000/svg"
        // animate={{
        //   x: '-100vw',
        // }}
        // transition={{
        //   loop: Infinity,
        //   ease: 'linear',
        //   duration: 12,
        // }}
      >
        <defs>
          <motion.polyline
            fill="transparent"
            id="a"
            points={points}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
          />
          <linearGradient id="linear" x1="0%" x2="100%" y1="0%" y2="0%">
            {logoStops?.map((stop, idx) => {
              const colorStops = [
                ...logoStops.slice(idx),
                ...logoStops.slice(0, idx),
              ];

              return (
                <motion.stop
                  animate={{
                    stopColor: colorStops,
                  }}
                  offset={`${((idx / color.logoStops.length) * 100).toFixed(
                    0
                  )}%`}
                  stopColor={stop}
                  transition={{
                    yoyo: Infinity,
                    ease: "linear",
                    duration: 6,
                  }}
                />
              );
            })}
          </linearGradient>
        </defs>
        <use
          fill="transparent"
          stroke="url(#linear)"
          strokeWidth="2"
          transform="translate(0,100)"
          xlinkHref="#a"
        />
      </motion.svg>
    </div>
  );
};

export default SineWave;

// TweenLite.defaultEase = Sine.easeInOut;
// TweenLite.defaultEase = Linear.easeNone
// TweenLite.set('g', { y: window.innerHeight / 2 })

// var svg = document.querySelector('svg')
// var $wave = document.querySelector('#wave')

// var contour1 = new CustomEase(
//   'contour1',
//   'M0,0 C0.4,0 0.3,1 0.5,1 0.7,1 0.6,0 1,0',
// )
// var contour2 = new CustomEase('contour2', 'M0,0,C0,0,0.5,1,0.5,1,0.5,1,1,0,1,0')
// var contour3 = new CustomEase(
//   'contour3',
//   'M0,0,C0,0.302,0,1,0.2,1,0.4,1,0.6,0,1,0',
// )

// var width = 800
// var segments = 500
// var interval = width / segments

// var wave = {
//   amplitude: 0,
//   frequency: 1,
//   points: [],
// }

// for (var i = 0; i <= segments; i++) {
//   var period = i / segments
//   var point = $wave.points.appendItem(svg.createSVGPoint())

//   point.x = i * interval
//   point.y = 0

//   wave.points.push({
//     ratio: 0,
//     period: period,
//     point: point,
//     update: function() {
//       var cycle = Math.sin(this.period * wave.frequency * Math.PI * 2)
//       var height = (this.ratio * wave.amplitude) / 2
//       this.point.y = cycle * height
//     },
//   })
// }

// update()

// var tl1 = new TimelineMax({ repeat: -1, yoyo: true })
//   .to(wave, 1, { amplitude: 200, repeat: 1, yoyo: true })
//   .to(wave, 0.5, { amplitude: 150, repeat: 1, yoyo: true })
//   .to(wave, 1, { amplitude: 300, repeat: 1, yoyo: true })

// var tl2 = new TimelineMax({ repeat: -1, yoyo: true })
//   .to(wave, 2, { frequency: 15 })
//   .to(wave, 2, { frequency: 5 }, '+=1')
//   .to(wave, 2, { frequency: 10 }, '+=1')

// var tl3 = new TimelineMax({ repeat: -1, yoyo: true })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       return contour1.getRatio(point.period)
//     },
//   })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       return contour2.getRatio(point.period)
//     },
//   })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       return contour3.getRatio(point.period)
//     },
//   })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       var period = 1

//       // Constrain the contour to the first 25%
//       if (point.period <= 0.25) {
//         period = map(point.period, 0, 0.25, 0, 1)
//       }

//       return contour1.getRatio(period)
//     },
//   })
//   .to(wave.points, 1, {
//     ratio: function(i, point) {
//       // No wave
//       return 0
//     },
//   })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       // Reverse of contour3.getRatio(point.period);
//       return contour3.getRatio(1 - point.period)
//     },
//   })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       // Slope down
//       return 1 - point.period
//     },
//   })
//   .to(wave.points, 2, {
//     ratio: function(i, point) {
//       // Slope up
//       return point.period
//     },
//   })

// TweenLite.ticker.addEventListener('tick', update)

// /**
//  * @param {number} x value to map
//  * @param {number} a source min value
//  * @param {number} b source max value
//  * @param {number} c destination min value
//  * @param {number} d destination max value
//  */
// function map(x, a, b, c, d) {
//   return c + (d - c) * ((x - a) / (b - a)) || 0
// }

// function update() {
//   var len = wave.points.length

//   for (var i = 0; i < len; i++) {
//     wave.points[i].update()
//   }
// }
